import styles from "../../../AccountingPage.module.scss";
import { useEffect, useState, useRef } from "react";
import Notification from "utils/Notifications";
import { Button } from "components";
import { useReactToPrint } from "react-to-print";
import {
    getDepartmentsData,
    getPositionsData,
    getEmployeeDetailData,
    getBranchesData,
} from "service/AccountingService";
import EmployeeHistoryContent from "./components/EmployeeHistoryContent";
import EmployeeHystoryPayListContent from "./components/EmployeeHystoryPayListContent";
import EmployeeSalaryHistoryContent from "./components/EmployeeSalaryHistoryContent";
import EmployeeDetailForms from "./EmployeeDetailForms"; // новый компонент

const EmployeeDetailContent = ({
    render,
    setRender,
    id,
    nameEmployee,
    onBack,
    foun_id,
}) => {
    const sections = [
        { key: "hisotypay", label: "Оклад, Надбавки, Удержания", Component: EmployeeHystoryPayListContent },
        { key: "history", label: "Движение сотрудника", Component: EmployeeHistoryContent },
        { key: "historysalary", label: "История выплат", Component: EmployeeSalaryHistoryContent },
    ];

    const [activeSection, setActiveSection] = useState(null);
    const handleShowSection = (key) => {
        setActiveSection((prev) => (prev === key ? null : key));
    };

    const componentRef1 = useRef();

    // Справочники
    const [departments, setDepartments] = useState([]);
    const [positions, setPositions] = useState([]);
    const [branchID, setBranchID] = useState("");
    const [branches, setBranches] = useState([]);
    const getBranches = async (foun_id) => {
        try {
            let response = await getBranchesData(foun_id, branches);
            setBranches(response.data);
        } catch (error) {
            console.log("onoxo")
        }
    };
    const getDepartments = async (id) => {
        try {
            let response = await getDepartmentsData(id);
            setDepartments(response.data);
        } catch (error) {
            console.log("Ошибка получения подразделений");
        }
    };
    const getPositions = async (foun_id) => {
        try {
            let response = await getPositionsData(foun_id);
            setPositions(response.data);
        } catch (error) {
            console.log("Ошибка получения должностей");
        }
    };
    const handleSelectBranch = (id) => {
        setBranchID(id);
        getDepartments(id)
    };

    // Данные сотрудника
    const [data, setData] = useState({});
    const [status, setStatus] = useState("");
    const [order, setOrder] = useState("");
    const [stavka, setStavka] = useState("");
    const [departmentID, setDepartmentID] = useState("");
    const [positionID, setPositionID] = useState("");
    const [editDateFrom, setEditDateFrom] = useState("");
    const [editDateTo, setEditDateTo] = useState("");

    useEffect(() => {
        getBranches(foun_id);
        getPositions(foun_id);
        getData(id);
        setRender(false);
        // eslint-disable-next-line
    }, [render]);
    const getData = async (id) => {
        try {
            let response = await getEmployeeDetailData(id);
            setData(response.data);
            setStatus(response.data.status || "");
            setData(response.data);
            setOrder(response.data.order || "");
            setDepartmentID(response.data.department || "");
            setPositionID(response.data.position || "");
            setStavka(response.data.stavka || "");
            setStatus(response.data.status || "");
        } catch (error) {
            console.log("Ошибка получения данных сотрудника");
        }
    };

    const handlePrint1 = useReactToPrint({
        content: () => componentRef1.current,
    });

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const [activeForm, setActiveForm] = useState("");

    // Кнопки действий по статусу
    const statusButtons = [
        {
            show: status === "Работает",
            buttons: [
                {
                    label: "Выплата",
                    onClick: () => setActiveForm("salarypay"), // пока пусто
                    style: { background: "#800080", color: "#fff" },
                },
                {
                    label: "Оклад",
                    onClick: () => setActiveForm("salary"),
                    style: { background: "#2e8b57" },
                },
                {
                    label: "Надбавка",
                    onClick: () => setActiveForm("allowance"),
                    style: { background: "#20b2aa" },
                },
                {
                    label: "Удержание",
                    onClick: () => setActiveForm("deduction"),
                    style: { background: "#b22222" },
                },
                {
                    label: "Изменить данные",
                    onClick: () => setActiveForm("edit"),
                    style: { background: "#5c5cff" },
                },
                {
                    label: "Уволить",
                    onClick: () => setActiveForm("fire"),
                    style: { background: "#a00000ff" },
                },
                {
                    label: "В отпуск",
                    onClick: () => setActiveForm("leave"),
                    style: { background: "#ec9900ff" },
                },
                {
                    label: "В командировку",
                    onClick: () => setActiveForm("trip"),
                    style: { background: "#333333" },
                },
                {
                    label: "На больничный",
                    onClick: () => setActiveForm("sick"),
                    style: { background: "#0a62a3" },
                },
                {
                    label: "В декрет",
                    onClick: () => setActiveForm("maternity"),
                    style: { background: "#ffb6c1" },
                },
                {
                    label: "В отпуск без содержания",
                    onClick: () => setActiveForm("unpaidleave"),
                    style: { background: "#20d300" },
                },
            ],
        },
        {
            show: status === "Уволен(а)",
            buttons: [
                {
                    label: "Восстановить",
                    onClick: () => setActiveForm("restore"),
                    style: { background: "#008000ff" },
                },
                {
                    label: "Отменить увольнение",
                    onClick: () => setActiveForm("cancelfire"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "В отпуске",
            buttons: [
                {
                    label: "Выплата",
                    onClick: () => setActiveForm("salarypay"), // пока пусто
                    style: { background: "#800080", color: "#fff" },
                },
                {
                    label: "Вернуть с отпуска",
                    onClick: () => setActiveForm("backleave"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "В командировке",
            buttons: [
                {
                    label: "Выплата",
                    onClick: () => setActiveForm("salarypay"), // пока пусто
                    style: { background: "#800080", color: "#fff" },
                },
                {

                    label: "Вернуть с командировки",
                    onClick: () => setActiveForm("backtrip"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "На больничном",
            buttons: [
                {
                    label: "Выплата",
                    onClick: () => setActiveForm("salarypay"), // пока пусто
                    style: { background: "#800080", color: "#fff" },
                },
                {
                    label: "Вернуть с больничного",
                    onClick: () => setActiveForm("backsick"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "В декретном отпуске",
            buttons: [
                {
                    label: "Выплата",
                    onClick: () => setActiveForm("salarypay"), // пока пусто
                    style: { background: "#800080", color: "#fff" },
                },
                {
                    label: "Вернуть с декрета",
                    onClick: () => setActiveForm("backmaternity"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "В отпуске без содержания",
            buttons: [

                {
                    label: "Вернуть с отпуска без содержания",
                    onClick: () => setActiveForm("backunpaidleave"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
        {
            show: status === "",
            buttons: [
                {
                    label: "Изменить данные",
                    onClick: () => setActiveForm("edit"),
                    style: { background: "#5c5cff" },
                },
            ],
        },
    ];


    return (
        <>
            <div className={styles.content_header}>
                <div className={styles.content_header_in}>
                    <Button className={styles.btn_pin} onClick={onBack}>
                        ⬅ Назад
                    </Button>
                    <h2 className={styles.project__h}>Сотрудники/{nameEmployee}</h2>
                </div>
            </div>

            <div className={styles.content_header}>
                <div className={styles.content_header_in}>
                    <h2 className={styles.project__h}>Актуальные данные сотрудника</h2>
                </div>
                <div className={styles.table__item__div}>
                    {activeForm && (
                        <button
                            className={styles.open_btn_sub_two}
                            style={{ background: "black" }}
                            onClick={() => setActiveForm("")}
                        >
                            Закрыть ❌
                        </button>
                    )}

                    {/* Выплата */}
                    {statusButtons.map(
                        (group) =>
                            group.show &&
                            group.buttons
                                .filter((btn) => btn.label === "Выплата")
                                .map((btn) => {
                                    const btnActiveForm = btn.onClick?.toString().match(/setActiveForm\("([^"]+)"\)/)?.[1];
                                    const isActive = activeForm === btnActiveForm;
                                    return (
                                        <button
                                            key={btn.label}
                                            onClick={btn.onClick}
                                            className={styles.open_btn_sub_two}
                                            style={{
                                                ...btn.style,
                                                background: isActive ? btn.style.background : "rgb(59 59 59)",
                                                color: btn.style.color || "white",
                                                marginRight: 4
                                            }}
                                        >
                                            {btn.label}
                                        </button>
                                    );
                                })
                    )}

                    {/* Оклад, Надбавка, Удержание */}
                    <div style={{ display: "inline-block", marginLeft: 10, marginRight: 10 }}>
                        {statusButtons.map(
                            (group) =>
                                group.show &&
                                group.buttons
                                    .filter((btn) =>
                                        ["Оклад", "Надбавка", "Удержание"].includes(btn.label)
                                    )
                                    .map((btn) => {
                                        const btnActiveForm = btn.onClick?.toString().match(/setActiveForm\("([^"]+)"\)/)?.[1];
                                        const isActive = activeForm === btnActiveForm;
                                        return (
                                            <button
                                                key={btn.label}
                                                onClick={btn.onClick}
                                                className={styles.open_btn_sub_two}
                                                style={{
                                                    ...btn.style,
                                                    background: isActive ? btn.style.background : "rgb(59 59 59)",
                                                    color: btn.style.color || "white",
                                                    marginRight: 4
                                                }}
                                            >
                                                {btn.label}
                                            </button>
                                        );
                                    })
                        )}
                    </div>

                    {/* Изменить данные */}
                    {statusButtons.map(
                        (group) =>
                            group.show &&
                            group.buttons
                                .filter((btn) => btn.label === "Изменить данные")
                                .map((btn) => {
                                    const btnActiveForm = btn.onClick?.toString().match(/setActiveForm\("([^"]+)"\)/)?.[1];
                                    const isActive = activeForm === btnActiveForm;
                                    return (
                                        <button
                                            key={btn.label}
                                            onClick={btn.onClick}
                                            className={styles.open_btn_sub_two}
                                            style={{
                                                ...btn.style,
                                                background: isActive ? btn.style.background : "rgb(59 59 59)",
                                                color: btn.style.color || "white",
                                                marginRight: 4
                                            }}
                                        >
                                            {btn.label}
                                        </button>
                                    );
                                })
                    )}

                    {/* Остальные */}
                    <div style={{ display: "inline-block", marginLeft: 10 }}>
                        {statusButtons.map(
                            (group) =>
                                group.show &&
                                group.buttons
                                    .filter((btn) =>
                                        !["Выплата", "Оклад", "Надбавка", "Удержание", "Изменить данные"].includes(btn.label)
                                    )
                                    .map((btn) => {
                                        const btnActiveForm = btn.onClick?.toString().match(/setActiveForm\("([^"]+)"\)/)?.[1];
                                        const isActive = activeForm === btnActiveForm;
                                        return (
                                            <button
                                                key={btn.label}
                                                onClick={btn.onClick}
                                                className={styles.open_btn_sub_two}
                                                style={{
                                                    ...btn.style,
                                                    background: isActive ? btn.style.background : "rgb(59 59 59)",
                                                    color: btn.style.color || "white",
                                                    marginRight: 4
                                                }}
                                            >
                                                {btn.label}
                                            </button>
                                        );
                                    })
                        )}
                    </div>
                </div>
            </div>

            <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                    <tr className={styles.table__row}>
                        <th className={styles.table__item}><span className={styles.table__title}>ИНН</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Фамилия</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Имя</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Отчество</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Номер телефона</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Подразделение</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Должность</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Ставка</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Приказ</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Период</span></th>
                        <th className={styles.table__item_student}><span className={styles.table__title}>Статус</span></th>
                    </tr>
                </thead>
                <tbody className={styles.table__body}>
                    <tr className={styles.table__row} key={data.id}>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data?.personaldata?.inn}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data?.personaldata?.surname}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data?.personaldata?.first_name}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data?.personaldata?.last_name}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data?.personaldata?.number_phone}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data.department_name}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data.posititon_name}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data.stavka}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data.order}</span></td>
                        <td className={styles.table__item_student}><span className={styles.table__title} style={{ fontWeight: "700" }}>{data.date_from || ""} - {data.date_to || ""}</span></td>
                        <td className={styles.table__item_student}>
                            <span
                                className={styles.table__title}
                                style={{
                                    fontWeight: "700",
                                    padding: "5px",
                                    borderRadius: "6px",
                                    display: "block",
                                    textAlign: "center",
                                    background:
                                        status === "Работает"
                                            ? "#5C5CFF"
                                            : status === "Уволен(а)"
                                                ? "#a00000ff"
                                                : status === "В отпуске"
                                                    ? "#ec9900ff"
                                                    : status === "В командировке"
                                                        ? "#333333"
                                                        : status === "На больничном"
                                                            ? "#0a62a3"
                                                            : status === "В декретном отпуске"
                                                                ? "#ffb6c1"
                                                                : status === "В отпуске без содержания"
                                                                    ? "rgb(59 59 59)"
                                                                    : "transparent",
                                    color: status ? "white" : "inherit",
                                }}
                            >
                                {status || ""}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            {/* Вставляем новый компонент форм */}
            <EmployeeDetailForms
                activeForm={activeForm}
                setActiveForm={setActiveForm}
                setNotify={setNotify}
                setRender={setRender}
                id={id}
                data={data}
                foun_id={foun_id}
                departments={departments}
                setDepartments={setDepartments}
                positions={positions}
                setPositions={setPositions}
                branchID={branchID}
                setBranchID={setBranchID}
                branches={branches}
                handleSelectBranch={handleSelectBranch}
                order={order}
                stavka={stavka}
                editDateFrom={editDateFrom}
                editDateTo={editDateTo}
                departmentID={departmentID}
                positionID={positionID}
                setPositionID={setPositionID}
                setDepartmentID={setDepartmentID}
                setOrder={setOrder}
                setStavka={setStavka}
                setEditDateFrom={setEditDateFrom}
                setEditDateTo={setEditDateTo}
            />

            <div className={styles.project__body_second}>
                <div style={{ display: "flex" }}>
                    <div className={styles.project__menu}>
                        {sections.map(({ key, label }) => (
                            <div
                                key={key}
                                className={
                                    activeSection === key
                                        ? styles.project__menu__item__active
                                        : styles.project__menu__item
                                }
                            >
                                <h2
                                    onClick={() => handleShowSection(activeSection === key ? null : key)}
                                    style={{ cursor: "pointer" }}
                                >
                                    {label} {activeSection === key ? "🔼" : "🔽"}
                                </h2>
                            </div>
                        ))}
                    </div>
                    <button
                        className={styles.btn_print}
                        style={{ fontSize: "28px" }}
                        onClick={handlePrint1}
                    >
                        🖨️
                    </button>
                </div>
            </div>
            <div ref={componentRef1} style={{ width: "100%" }}>
                {sections.map(
                    ({ key, Component }) =>
                        activeSection === key &&
                        Component && (
                            <Component
                                key={key}
                                render={render}
                                setRender={setRender}
                                id={id}
                                dataemployee={data}
                            />
                        )
                )}
            </div>
            <Notification notify={notify} setNotify={setNotify} />
        </>
    );
};

export default EmployeeDetailContent;